<template>
  <div class="mes-system">
    <div class="solution-banner">
      <img src="@/assets/images/website/solution/mes-system/banner.png" />
    </div>
    <div class="processing-enterprise">
      <div class="website-container">
        <h2>为有色金属加工企业提供MES生产制造执行系统</h2>
        <span>本系统实现有色金属加工订单合并及排产、物料配比流转跟踪、设备故障预防控制、产品生产成本治理、全生命周期质量追溯、全过程数据分析应用，建成一个集产品、设备、工艺、人员智能协同管控的，满足工艺目标和经济指标的在线智能优化的系统平台。该平台具有生产计划排程优化、设备状态监测与故障诊断、产品质量全流程溯控、物料流转实时跟踪、生产全过程数据实时展现和智能分析优化等综合功能，形成有色金属加工智能协同管控一体化解决方案。</span>
        <img alt src="@/assets/images/website/solution/mes-system/part_1.png" />
        <Row style="margin-top:10px;">
          <Col span="15">
            <img alt src="@/assets/images/website/solution/mes-system/part_2_1.png" />
          </Col>
          <Col span="9">
            <img alt src="@/assets/images/website/solution/mes-system/part_2_2.png" />
            <img alt src="@/assets/images/website/solution/mes-system/part_2_3.png" />
          </Col>
        </Row>
        <img alt src="@/assets/images/website/solution/mes-system/part_3.png" style="margin-top:10px;" />
      </div>
    </div>
    <div class="manufacturing-enterprise">
      <div class="website-container">
        <h2>为有色金属装备制造企业提供全方面生产管理解决方案</h2>
        <img alt src="@/assets/images/website/solution/mes-system/part_4.png" />
        <div>
          <img alt src="@/assets/images/website/solution/mes-system/part_5_1.png" />
          <img alt src="@/assets/images/website/solution/mes-system/part_5_2.png" style="margin-left:20px;" />
        </div>
        <img alt class="last-item" src="@/assets/images/website/solution/mes-system/part_6.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style scoped lang="less">
.solution-banner {
  width: 100%;
  img {
    width: 100%;
    object-fit: cover;
  }
}
.processing-enterprise {
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  span {
    line-height: 28px;
    text-align: justify;
  }
  img {
    width: 100%;
  }
}
.manufacturing-enterprise {
  background: linear-gradient(#f6f7f9, #ffffff);
  padding-top: 30px;
  h2 {
    line-height: 40px;
    margin: 10px 0 20px 0;
  }
  .last-item {
    width: 100%;
  }
}
</style>
